import { InjectionToken } from '@angular/core';

export const AUTH_USER_PROPERTY = new InjectionToken<string>('AUTH_USER_PROPERTY');
